// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */
.modalOverlay_STDxg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000033-background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: opacity 300ms ease-in-out;
  border-radius: 10px;
}

.modalContent_fWBUU {
  display: flex;
  flex-direction: column;
  background-color: var(--f5-background);
  border-radius: 8px;
  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */
  width: 515px;
  gap: 0px;
  transform: scale(1);
  animation: scaleUp_W22az 300ms ease-out forwards;
  font-family: "Inter", sans-serif;
  overflow: hidden;
  @media (width<=768px) {
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
  }
}

.scaleDown_kRDgd {
  animation: scaleDown_kRDgd 300ms ease-in forwards;
}

@keyframes scaleUp_W22az {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_kRDgd {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}

.fadeOut_bVQlB {
  opacity: 0;
}

.headerLeft_OSwai {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 10px;
}
.closeIcon_OWDX6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.footerContainer_WbtcK {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  height: 64px;
  border-top: 1px solid var(--e3-border);
  gap: 16px;
}

.newFolderButton_hIeqC {
  color: var(--_2-color);
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin: 10px 0;
  font-weight: 500;
}

.selectButton_ZkXsu {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-color);
  padding: 12.5px 24px;
  border-radius: 8px;
  background: var(--_10a37f-background);
  border: 1px solid var(--_10a37f-border);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.contentContainer_iU7FX {
  display: flex;
  flex-direction: column;
  padding: 0px 10px 10px;
  max-height: 55vh;
  overflow-y: auto;

  .content_YkL7U {
    background-color: var(--white-background);
    box-sizing: border-box;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    padding: 10px;
  }

  @media (width<=768px) {
    height: 100%;
    max-height: 100%;
    align-items: center;
    justify-content: center;
    .content_YkL7U {
      width: 80%;
    }
  }
}
.contentContainer_iU7FX::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contentContainer_iU7FX::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}
.contentContainer_iU7FX::-webkit-scrollbar-track {
  background: transparent;
}
.folderHeader___hLU {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  height: 33px;
  position: relative;
  min-height: 33px;
  -webkit-user-select: none;
          user-select: none;
  span {
    cursor: pointer;
    color: var(--_1f184b-color);
    font-size: 14px;
    font-weight: 500;
    &::first-letter {
      text-transform: uppercase;
    }
  }
}

.folderInnerContainer_YQD7C {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 29px;
  flex-direction: row;
  padding: 0px 14px;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
}
.curvedLine_C5UiZ {
  position: absolute;
  left: -20px;
  top: 0;
}
.folderItem_jUIMb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.subFolders_qCUs5 {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
}

.folderItem_jUIMb.expanded_gUTnr .subFolders_qCUs5 {
  max-height: 1000px;
  opacity: 1;
}
.verticalLine_tgHSQ {
  position: absolute;
  width: 2px;
  background-color: var(--d9-background);
  height: calc(100% - 25px);
  bottom: 25px;
  z-index: 9999999;
}

.chevron_Vogzv {
  position: absolute;
  right: 20px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SelectLocation/SelectLocation.module.css"],"names":[],"mappings":"AAAA,qGAAqG;AACrG;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,gDAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,iDAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB;IACE,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB;;4BAE0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000033-background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  transition: opacity 300ms ease-in-out;\n  border-radius: 10px;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */\n  width: 515px;\n  gap: 0px;\n  transform: scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n  @media (width<=768px) {\n    max-width: 100vw;\n    width: 100vw;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 10px;\n}\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 24px;\n  height: 64px;\n  border-top: 1px solid var(--e3-border);\n  gap: 16px;\n}\n\n.newFolderButton {\n  color: var(--_2-color);\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n  margin: 10px 0;\n  font-weight: 500;\n}\n\n.selectButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-color);\n  padding: 12.5px 24px;\n  border-radius: 8px;\n  background: var(--_10a37f-background);\n  border: 1px solid var(--_10a37f-border);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 0px 10px 10px;\n  max-height: 55vh;\n  overflow-y: auto;\n\n  .content {\n    background-color: var(--white-background);\n    box-sizing: border-box;\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    padding: 10px;\n  }\n\n  @media (width<=768px) {\n    height: 100%;\n    max-height: 100%;\n    align-items: center;\n    justify-content: center;\n    .content {\n      width: 80%;\n    }\n  }\n}\n.contentContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.contentContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n.contentContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n.folderHeader {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 20px;\n  height: 33px;\n  position: relative;\n  min-height: 33px;\n  user-select: none;\n  span {\n    cursor: pointer;\n    color: var(--_1f184b-color);\n    font-size: 14px;\n    font-weight: 500;\n    &::first-letter {\n      text-transform: uppercase;\n    }\n  }\n}\n\n.folderInnerContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 29px;\n  flex-direction: row;\n  padding: 0px 14px;\n  width: 100%;\n  border-radius: 3px;\n  box-sizing: border-box;\n}\n.curvedLine {\n  position: absolute;\n  left: -20px;\n  top: 0;\n}\n.folderItem {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n}\n\n.subFolders {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition:\n    max-height 0.3s ease-in-out,\n    opacity 0.3s ease-in-out;\n}\n\n.folderItem.expanded .subFolders {\n  max-height: 1000px;\n  opacity: 1;\n}\n.verticalLine {\n  position: absolute;\n  width: 2px;\n  background-color: var(--d9-background);\n  height: calc(100% - 25px);\n  bottom: 25px;\n  z-index: 9999999;\n}\n\n.chevron {\n  position: absolute;\n  right: 20px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay_STDxg`,
	"modalContent": `modalContent_fWBUU`,
	"scaleUp": `scaleUp_W22az`,
	"scaleDown": `scaleDown_kRDgd`,
	"fadeOut": `fadeOut_bVQlB`,
	"headerLeft": `headerLeft_OSwai`,
	"closeIcon": `closeIcon_OWDX6`,
	"footerContainer": `footerContainer_WbtcK`,
	"newFolderButton": `newFolderButton_hIeqC`,
	"selectButton": `selectButton_ZkXsu`,
	"contentContainer": `contentContainer_iU7FX`,
	"content": `content_YkL7U`,
	"folderHeader": `folderHeader___hLU`,
	"folderInnerContainer": `folderInnerContainer_YQD7C`,
	"curvedLine": `curvedLine_C5UiZ`,
	"folderItem": `folderItem_jUIMb`,
	"subFolders": `subFolders_qCUs5`,
	"expanded": `expanded_gUTnr`,
	"verticalLine": `verticalLine_tgHSQ`,
	"chevron": `chevron_Vogzv`
};
export default ___CSS_LOADER_EXPORT___;
